import { UserRowRoleType } from '@modules/users/store/types';
import { PermissionResource } from 'generated/graphql';

export type InviteUserRoleType = UserRowRoleType.Admin | UserRowRoleType.Member;

export interface DomainUsersTableRow {
  domain: string;
  userCount: number;
}

export enum PermissionTableOperation {
  Edit = 'Edit',
  View = 'View',
  None = 'None',
}

export interface PermissionsTableRow {
  module: PermissionResource;
  adminOperation: PermissionTableOperation;
  memberOperation: PermissionTableOperation;
}
